export default "__VITE_ASSET__grFab5yj__"